<template>
  <UContainer>
    <ExpandableList v-slot="{ displayItems }" :items="trainers" :limit="9">
      <CommonGridCards :items="displayItems" :pending="pending">
        <template #card="{ item }">
          <CommonCard
            :item="item"
            :to="`/trainers/${item.id}`"
            :description-under-left="descriptionUnder"
            image-top-left="directions"
            title-above-left="school"
            title-right="directions"
            :ui="{
              title: 'max-sm:line-clamp-1',
              bodyHeader: 'mb-5!',
            }"
          >
          </CommonCard>
        </template>
      </CommonGridCards>
    </ExpandableList>
  </UContainer>
</template>

<script lang="ts" setup>
import ExpandableList from '~/components/ExpandableList.vue'
import type { IconWithLabel } from '~/types'

defineOptions({
  name: 'SchoolDetailTrainers',
})

const route = useRoute()
const directoryStore = useDirectoryStore()
const { trainers } = storeToRefs(directoryStore)

const { untilReady } = useRegionReady()

const { pending } = await useAppAsyncData(
  `school-trainers-${route.params.id}`,
  async () => {
    await untilReady()
    await directoryStore.fetchTrainers()
  },
)

const descriptionUnder: IconWithLabel[] = [
  {
    icon: 'i-local-graduation-cap',
    label: 'Опыт: ',
    value: '24 мока',
    iconClass: '',
  },
  {
    icon: 'i-local-award',
    label: 'Награды: ',
    value: '104',
    iconClass: 'bg-warning-light',
  },
]
</script>

<style lang="scss" scoped>
:deep(.common-card) {
  --card-height: 456px;
  --card-image-height: 240px;

  @include max-xl {
    --card-height: 380px;
    --card-image-height: 200px;
  }

  @include max-md {
    --card-height: 335px;
    --card-image-height: 160px;

    :deep(.body-header) {
      display: none;
    }
  }
}
</style>
